import { defineSaleProgress, isSaleSigned, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface ProtectedData extends ProgressSaleData {
  scriptSteps?: Record<string, string> | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export default defineSaleProgress<ProtectedData>({
  kind: 'sale',
  cascade: true,
  steps: [
    { key: 'accord', label: `${TIMELINE}accord`, done: data => !!data.scriptSteps?.accordPresentation },
    { key: 'sms_code', label: `${TIMELINE}sms_code`, done: isSaleStarted },
    { key: 'signature', label: `${TIMELINE}signature`, done: isSaleSigned },
  ],
})
